import React, { FC } from 'react';
import { RedirectProps } from 'react-router';
import { Redirect, useHistory } from 'react-router-dom';

export const RedirectWithQuery: FC<RedirectProps> = (props) => {
  const history = useHistory();
  return <Redirect {...props} to={`${props.to}${history.location.search}`} />;
};
